import { cn } from "@/lib/utils";

function Container({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-[7px]",
        className,
      )}
      {...props}
    />
  );
}

function Item({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      className={cn(
        "flex w-full items-center gap-2 text-sm font-normal text-heading sm:w-[152px] sm:shrink-0",
        className,
      )}
      {...props}
    />
  );
}

function Value({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      className={cn("flex w-full min-w-0 items-center sm:w-auto sm:flex-1", className)}
      {...props}
    />
  );
}

const ContactLayout = { Container, Item, Value };
export default ContactLayout;
